module.exports = __webpack_public_path__ + "static/img/fullscreen-image_ready-made-reports_600.5260663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_ready-made-reports_600.png
// module id = JQaD
// module chunks = 0